<script setup lang="ts">
import PhotoData from './wellbeing-sale--forWorkers.const'
import type { IPhotoWithDescriptionFields } from '@/types/contentful'
import UiPhotoWithDescription from '@/components/UiPhotoWithDescription/UiPhotoWithDescription.vue'

const { uiPhotoData } = PhotoData()
</script>

<template>
  <div class="forWorkers">
    <h6 class="forWorkers__title">
      {{ $t('wellbeingSale.forWorkers.title') }}
    </h6>

    <p class="forWorkers__subtitle">
      {{ $t('wellbeingSale.forWorkers.paragraph1') }}
    </p>

    <UiPhotoWithDescription
      v-bind="uiPhotoData() as unknown as IPhotoWithDescriptionFields"
    />

    <p class="forWorkers__paragraph">
      {{ $t('wellbeingSale.forWorkers.paragraph2') }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.forWorkers {
  max-width: 132rem;
  width: 90%;
  margin: auto;
  padding: 5rem 1.6rem;

  &__title {
    @include h8;
    display: block;
    text-align: center;
  }

  &__subtitle {
    @include body-2-medium;
    max-width: 69rem;
    margin: 0 auto;
    padding-top: 2.4rem;
    padding-bottom: 4.8rem;
    text-align: center;
  }

  &__paragraph {
    @include body-2-medium;
    max-width: 69rem;
    margin: 0 auto;
    padding-top: 4rem;
    text-align: center;
  }

  :deep(.cf-photoWithDescription__photoDesktop) {
    width: 100%;
    border-radius: 1.6rem;
  }

  :deep(.cf-photoWithDescription__contentText--big) {
    @include h10;
  }

  @include atM {
    padding: 10rem 0;

    &__title {
      @include h5;
    }

    &__subtitle {
      @include body-1-medium;
    }

    &__paragraph {
      @include body-1-medium;
    }

    :deep(.cf-photoWithDescription__contentText--big) {
      @include h9;
    }
  }
  
  @include atL {
    width: 100%;
  }
}

</style>
